import React from "react";
import Logo from "@/components/site/Logo";
import { Instagram } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[var(--luft-ink)] text-[#F6F4EE]" data-testid="site-footer">
      <div className="max-w-[1440px] mx-auto px-6 sm:px-10 lg:px-16 pt-20 pb-10">
        <div className="grid grid-cols-12 gap-y-12 lg:gap-x-12">
          <div className="col-span-12 lg:col-span-5">
            <Logo size="footer" />
            <p className="mt-8 font-body font-light text-[#F6F4EE]/70 max-w-md leading-relaxed text-sm">
              Lu.ft é um pequeno estúdio de Pilates dedicado ao movimento consciente, à
              respiração e a uma prática íntima do corpo.
            </p>
          </div>

          <div className="col-span-6 lg:col-span-2">
            <p className="eyebrow text-[#F6F4EE]/50 mb-4">Estúdio</p>
            <ul className="space-y-2 font-body font-light text-[#F6F4EE]/85 text-sm">
              <li><button onClick={() => document.getElementById("filosofia")?.scrollIntoView({behavior:"smooth"})} className="link-underline">O Lu.ft</button></li>
              <li><button onClick={() => document.getElementById("aulas")?.scrollIntoView({behavior:"smooth"})} className="link-underline">Aulas</button></li>
              <li><button onClick={() => document.getElementById("equipa")?.scrollIntoView({behavior:"smooth"})} className="link-underline">Equipa</button></li>
            </ul>
          </div>

          <div className="col-span-6 lg:col-span-2">
            <p className="eyebrow text-[#F6F4EE]/50 mb-4">Reservar</p>
            <ul className="space-y-2 font-body font-light text-[#F6F4EE]/85 text-sm">
              <li><a href="https://apps.apple.com/pt/app/luft-pilates-studio/id6761007459" target="_blank" rel="noopener noreferrer" className="link-underline" data-testid="footer-app-store">App Store</a></li>
              <li><a href="https://play.google.com/store/apps/details?id=pt.yogobooking.luftpilates&pcampaignid=web_share" target="_blank" rel="noopener noreferrer" className="link-underline" data-testid="footer-google-play">Google Play</a></li>
              <li><a href="https://wa.me/351912952121" target="_blank" rel="noopener noreferrer" className="link-underline">WhatsApp</a></li>
              <li><button onClick={() => document.getElementById("contactos")?.scrollIntoView({behavior:"smooth"})} className="link-underline">Mensagem</button></li>
            </ul>
          </div>

          <div className="col-span-12 lg:col-span-3">
            <p className="eyebrow text-[#F6F4EE]/50 mb-4">Contacto</p>
            <p className="font-body font-light text-[#F6F4EE]/85 text-sm leading-relaxed">
              Entroncamento, Portugal<br />
              geral@luftpilates.com<br />
              +351 912 952 121
            </p>
            <a
              href="https://instagram.com/lu.ft_pilates"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 mt-5 text-[#F6F4EE]/85 link-underline text-sm"
              data-testid="footer-instagram"
            >
              <Instagram size={16} strokeWidth={1.4} />
              @lu.ft_pilates
            </a>
            <a
              href="https://linktr.ee/pilates.luft"
              target="_blank"
              rel="noopener noreferrer"
              className="block mt-3 text-[#F6F4EE]/85 link-underline text-sm"
              data-testid="footer-linktree"
            >
              linktr.ee/pilates.luft
            </a>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-white/15 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <p className="eyebrow text-[#F6F4EE]/50">© {new Date().getFullYear()} Lu.ft Pilates Studio</p>
          <p className="font-display italic text-[#F6F4EE]/60 text-base">
            crafted with calm in Portugal
          </p>
        </div>
      </div>
    </footer>
  );
}
